export default class PlaceholderContext {}

